import React, { useEffect, useState } from "react";
import { closeModal } from "react-url-modal";
import { Modal } from "@/components";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import {
  fetchGetTournamentApplications,
  fetchMarkTournamentApplicationsAsSeen,
} from "@/redux/tournaments";
import { ITournamentApplication } from "@/redux/tournaments/types";
import { TournamentApplicationsContent } from "./components/TournamentApplicationsContent/TournamentApplicationsContent";
import styles from "./TournamentApplicationsModal.module.scss";

interface TournamentApplicationsModalProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  params?: {
    tournamentId?: string;
  };
}

const TournamentApplicationsModalComponent = ({
  setIsOpen,
  params = {},
}: TournamentApplicationsModalProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const tournamentId = params?.tournamentId ? parseInt(params.tournamentId, 10) : null;
  const [applications, setApplications] = useState<ITournamentApplication[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!tournamentId) {
      handleClose();
      return;
    }

    const loadApplications = async () => {
      try {
        setIsLoading(true);
        const response = await dispatch(
          fetchGetTournamentApplications(tournamentId)
        ).unwrap();
        setApplications(response.applications || []);

        // Отмечаем заявки как просмотренные
        if (response.applications && response.applications.length > 0) {
          const applicationIds = response.applications.map((app) => ({
            id: app.id,
            type: app.type,
          }));
          try {
            await dispatch(
              fetchMarkTournamentApplicationsAsSeen({
                applications: applicationIds,
              })
            ).unwrap();
          } catch (error) {
            // Игнорируем ошибки при отметке как просмотренные
            console.warn("Failed to mark applications as seen:", error);
          }
        }
      } catch (error) {
        console.error("Error loading tournament applications:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadApplications();
  }, [tournamentId, dispatch]);

  const handleClose = () => {
    closeModal();
    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  if (isLoading) {
    return (
      <Modal
        title="Загрузка..."
        isOpen={true}
        setIsOpen={setIsOpen || (() => {})}
        closeModal={handleClose}
        modalWindowWidth={500}
      >
        <div className={styles.loading}>Загрузка заявок...</div>
      </Modal>
    );
  }

  return (
    <Modal
      title={`Участники`}
      isOpen={true}
      setIsOpen={setIsOpen || (() => {})}
      closeModal={handleClose}
      modalWindowWidth={500}
      mobileContentSize="full-screen"
      firmBack
    >
      <TournamentApplicationsContent
        applications={applications}
        tournamentId={tournamentId!}
        onApplicationsChange={(updatedApplications) => {
          setApplications(updatedApplications);
        }}
      />
    </Modal>
  );
};

// Экспорт для react-url-modal
export default TournamentApplicationsModalComponent;
export const TournamentApplicationsModal = TournamentApplicationsModalComponent;
